import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../features/component/login/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.isVerified()) {
      // User is fully authenticated (login + VSAC verified)
      return true;
    } else if (this.authService.hasTempToken()) {
      // User has logged in but not verified VSAC
      this.router.navigate(['/vsac']);
      return false;
    } else {
      // User is not logged in
      this.router.navigate(['/login']);
      return false;
    }
  }
}
